import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IAudits } from '../interfaces/audit';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  constructor(private httpClient: HttpClient) {}

  getAudits(url: string, filters: any): Observable<IAudits> {
    return this.httpClient.get<IAudits>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IAudits>;
  }
}
